// @core/api/endpoints/notifications/test_channel.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TestChannelRequest,
  TestChannelResponse,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Test notification channel
 * Sends a test notification through the specified channel to verify it is properly configured and operational.
 */
export async function TestChannel(
  channel_id: string,
  data: TestChannelRequest,
  options?: RequestOptions
): Promise<TestChannelResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/channels/:channel_id/test`;
  requestPath = requestPath.replace(':channel_id', encodeURIComponent(channel_id));
  const requestOptions = options;
  return client.post<TestChannelResponse>(requestPath, data, requestOptions);
}
